import idleSpriteUrl from './assets/sprite-idle6.webp';
import readySpriteUrl from './assets/sprite-ready.webp';
import listeningSpriteUrl from './assets/sprite-listening.webp';
import thinkingSpriteUrl from './assets/sprite-thinking.webp';
import speakingSpriteUrl from './assets/sprite-speaking.webp';
import alertSpriteUrl from './assets/sprite-alert.webp';
import knowledgeSpriteUrl from './assets/sprite-knowledge.webp';
import errorSpriteUrl from './assets/sprite-error.webp';
import tickleSpriteUrl from './assets/sprite-tickle.webp';

export type MascotAnimationName = 'idle' | 'ready' | 'listening' | 'thinking' | 'speaking' | 'alert' | 'knowledge' | 'error' | 'tickle';

export interface MascotFrameAnimation {
  name: MascotAnimationName;
  label: string;
  spriteSrc: string;
  frameWidth: number;
  frameHeight: number;
  columns: number;
  rows: number;
  totalFrames: number;
  fps: number;
  loop: boolean;
}

const idleBase = {
  spriteSrc: idleSpriteUrl,
  frameWidth: 240,
  frameHeight: 240,
  columns: 10,
  rows: 6,
  totalFrames: 60,
  loop: true,
};

export const mascotAnimations: Record<MascotAnimationName, MascotFrameAnimation> = {
  idle: { ...idleBase, name: 'idle', label: '待机', fps: 12 },
  ready: { ...idleBase, name: 'ready', label: '已打开', spriteSrc: readySpriteUrl, fps: 12 },
  listening: { ...idleBase, name: 'listening', label: '旁听中', spriteSrc: listeningSpriteUrl, fps: 12 },
  thinking: { ...idleBase, name: 'thinking', label: '思考中', spriteSrc: thinkingSpriteUrl, fps: 10 },
  speaking: { ...idleBase, name: 'speaking', label: '提示中', spriteSrc: speakingSpriteUrl, fps: 12 },
  alert: { ...idleBase, name: 'alert', label: '有提醒', spriteSrc: alertSpriteUrl, fps: 14 },
  knowledge: { ...idleBase, name: 'knowledge', label: '知识联想', spriteSrc: knowledgeSpriteUrl, fps: 12 },
  error: { ...idleBase, name: 'error', label: '暂不可用', spriteSrc: errorSpriteUrl, fps: 8 },
  tickle: { ...idleBase, name: 'tickle', label: '开心互动', spriteSrc: tickleSpriteUrl, fps: 12, loop: false },
};

export const mascotCopy: Record<MascotAnimationName, string> = {
  idle: '需要我旁听会议时，点一下开始。',
  ready: '我在这里，开始录音后会帮你提示。',
  listening: '我正在旁听会议，先帮你记住上下文。',
  thinking: '我会结合转写和知识库，帮你联想、纠偏和补漏。',
  speaking: '这里可能有个值得展开的方向。',
  alert: '这里可能有个遗漏点。',
  knowledge: '我从知识库联想到一个相关方向。',
  error: '本轮提醒失败，录音不受影响。',
  tickle: '哈哈，好痒～我在呢，需要帮忙吗？',
};
